import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./pages/About";
import Approach from "./pages/Approach";
import Consultations from "./pages/Consultations";
import Contact from "./pages/Contact";
import {
  Heart,
  Flower2,
  Sparkles,
  Shield,
  ChefHat,
  ArrowUp,
  ChevronLeft,
  ChevronRight,
  Quote,
} from "lucide-react";
import NutritionTherapy from "./pages/NutritionTherapy";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
const reviews = [
  {
    name: "Ewa, 41",
    review: [
      "Working with Alex has been such a positive and empowering experience. I initially came to her for help with choosing the right supplements, but what I gained was so much more. She helped me understand what is actually happening in my body, which made me feel more in control of my health and confident in my choices.",
      "What I really value is her holistic approach. She looks at the whole picture rather than just isolated symptoms, and she strongly believes in testing before suggesting anything. This felt incredibly reassuring to me, as it meant we weren’t guessing, but making informed decisions based on what my body actually needed.",
      "She explains everything in a way that is easy to understand without ever feeling oversimplified. Alex is incredibly knowledgeable, but also very real and honest in her approach. She truly cares about the wellbeing of women and you can feel that in every conversation.",
      "What makes her stand out is that she genuinely lives what she teaches. She is authentic, passionate, and fully aligned with her work. I felt supported, listened to, and never judged. I would highly recommend her to any woman looking to better understand and support her health.",
    ],
  },
  {
    name: "Izabelle, 42",
    review: [
      "I had an excellent experience working with Aleks as a nutrition therapist.  One of the main reasons I chose to work with Aleks was her honest, passionate approach and genuine authenticity. Her passion for what she does is clear in every interaction, and it made me feel confident that I was in the right hands.",
      "I highly recommend her service to anyone seeking knowledgeable and genuinely supportive nutrition professional.",
      "I now feel more control of my health and am more confident in maintaining these positive changes in the long term. Through her guidance, I have adopted  healthier eating habits",
      "Thank you so much",
    ],
  },
  {
    name: "Lilly, 49",
    review: [
      "Working with Aleks has been one of the most genuinely refreshing experiences I’ve had. From the very beginning, I felt like I wasn’t just another client, she really took the time to understand me, what I needed, and even the things I couldn’t quite put into words yet.",
      "What I loved most about being her client was her honesty. She doesn't just tell people what they want to hear. She tells them what they need to hear, but in a way that feels supportive rather than critical. That balance is rare, and it builds a level of trust that made me feel completely safe opening up and actually doing the work.",
      "Since working with her, I’ve noticed real, tangible changes in my life. I feel clearer, more confident in my decisions, and far less stuck in patterns that used to hold me back. Things that once felt overwhelming now feel manageable, and I approach challenges with a completely different mindset. It’s not just surface level change, it feels like a deeper shift in how I see myself and what I’m capable of.",
      "Her passion really comes through in everything she does. It never feels like you’re going through the motions, she shows up fully, every time, and your authenticity makes such a difference. There’s no façade, just someone real, grounded, and genuinely invested in helping others grow.",
    ],
  },
  {
    name: "Paul, 45",
    review: [
      "Aleksandra is a breath of fresh air! Easy to talk to, passionate about helping people be better versions of themselves, knowledgeable, and always on hand to answer questions, however trivial or complicated. I absolutely love being her client, and my only regret is not knowing her sooner. I now feel like I can make the right choices for my body in a way that I can manage myself, which is even more than I could expect. I am forever grateful.",
    ],
  },
  {
    name: "Emilija, 49",
    review: [
      "I have known Aleks for many years. Her passion and desire to dedicate herself to nutrition, dietary research,  the use of dietary supplements, and natural products have been her lifestyle for a long time. Through her research, education, and daily application of her knowledge, Aleks allows us all to find  balance in our daily lives. The easy and understandable communication, the short and clear advice that Aleks shares with us about diet, the  use of natural supplements in our daily lives allow us all to improve our lifestyle, balance our mental health and maximise our energy to control stress. Struggling with perimenopause and the menopause period, for me was not a problem, but a new beginning.",
      "Having a personal nutritionist who dedicates her knowledge and time to each client with great attention, precision and love is a blessing in this day and age, and my blessing is Aleks.",
      "I am very happy to recommend Aleks' services and believe that every new client will benefit and be blessed like me.",
    ],
  },
  {
    name: "Ana Fernandez, 51",
    review: [
      "I met Aleks through a friend of mine, a client of hers. After sending Aleks my latest tests, she gave me the most detailed description of my current condition. Hashimoto's, menopause, insulin resistance. After many months of wandering from doctor to doctor, from nutritionist to nutritionist, my condition was becoming increasingly unbearable and frustrating. ",
      "With the advice that Aleks gave me, regarding the diet for the problem of Hashimoto's, to controlling insulin by taking the necessary supplements, vitamins, daily physical routine, as well as alleviating the symptoms of menopause, I can share that even after three weeks I feel much better, my energy is stabilizing and the desire for friendship and socialization is returning to my everyday life.",
      " I highly recommend Aleks to all women and other clients to follow her advice, her recommended diet menus, as well as the necessary physical activities, in order to restore balance in their lives.",
    ],
  },
];

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/consultations" element={<Consultations />} />
            <Route path="/nutrition-therapy" element={<NutritionTherapy />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />

          {/* Floating Back to Top Button */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-8 right-8 bg-gradient-to-r from-primary to-green-600 hover:from-green-700 hover:to-green-700 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 z-40"
            aria-label="Back to top"
          >
            <ArrowUp className="w-6 h-6" />
          </button>
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

function Home() {
  const navigate = useNavigate();
  const [activeReview, setActiveReview] = useState(0);

  const goToPreviousReview = () => {
    setActiveReview((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  const goToNextReview = () => {
    setActiveReview((prev) => (prev + 1) % reviews.length);
  };

  const selectedReview = reviews[activeReview];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Helmet>
        <title>
          Nutritional Therapy in Ealing | Evidence-Informed Health Solutions
        </title>
        <meta
          name="description"
          content="Transform your health with evidence-informed nutritional therapy in Ealing. Aleks, a registered nutritional therapist (BSc Hons, regCNHC, mBANT), offers personalised nutrition consulting and lifestyle support."
        />
        <meta
          name="keywords"
          content="nutritional therapist, nutrition consultation, nutritional therapy, personalised nutrition, health coaching, Ealing nutritionist"
        />
        <meta
          property="og:title"
          content="Nutritional Therapy in Ealing - Aleks"
        />
        <meta
          property="og:description"
          content="Discover how personalised nutrition and lifestyle changes can transform your health. Book a free discovery call today."
        />
        <meta property="og:type" content="website" />
      </Helmet>
      {/* Hero Section */}
      <div
        className="relative min-h-[90svh] md:min-h-[90vh] bg-cover bg-center bg-scroll md:bg-fixed flex items-center"
        style={{
          backgroundImage: "url('/vegetables1.jpg')",
        }}
      >
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/50 to-black/40"></div>

        {/* Hero Content */}
        <div className="relative z-10 container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <div className="max-w-3xl">
            <div className="mb-6 flex items-center gap-2">
              <div className="h-1 w-12 bg-gradient-to-r from-green-400 to-green-300 rounded-full"></div>
              <span className="text-green-300 font-semibold text-sm sm:text-base">
                Your Health Journey Starts Here
              </span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 md:mb-8">
              Personalised Nutrition & Lifestyle Support
            </h1>
            <p className="text-lg sm:text-xl text-white/95 leading-relaxed mb-8 md:mb-10 max-w-2xl">
              Hi, my name is Aleks, and I am a registered nutritional therapist.
              Together we can explore your unique circumstances and create{" "}
              <span className="bg-gradient-to-r from-green-300 to-green-400 bg-clip-text text-transparent font-semibold">
                personalised, evidence-informed
              </span>{" "}
              dietary and lifestyle changes that align with your health goals.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 mb-8">
              <button
                onClick={() =>
                  window.open(
                    "https://www.bookable.page/aleksandra",
                    "_blank",
                    "noopener,noreferrer",
                  )
                }
                className="bg-gradient-to-r from-primary to-green-600 hover:from-green-700 hover:to-green-700 text-white font-bold px-8 py-4 rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 text-base sm:text-lg transform hover:scale-105"
              >
                Book Your Free Discovery Call
              </button>
              <button
                onClick={() => navigate("/consultations")}
                className="bg-white/20 hover:bg-white/30 text-white font-semibold px-8 py-4 rounded-xl border-2 border-white/50 backdrop-blur-sm transition-all duration-300 text-base sm:text-lg"
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Conditions Section */}
      <div className="container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Do You Need Support With:
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Whether you're managing a specific condition or optimizing your
            health, I can help you achieve your goals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Condition Card 1 */}
          <div className="group bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="bg-gradient-to-br from-red-100 to-red-50 p-4 rounded-xl mb-6 w-fit group-hover:scale-110 transition-transform duration-300">
              <Heart className="w-8 h-8 text-red-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Metabolic Health
            </h3>
            <p className="text-gray-600 leading-relaxed">GLP support</p>
            <p className="text-gray-600 leading-relaxed">
              High blood sugar, blood pressure, weight management, and
              cholesterol imbalance support
            </p>
          </div>

          {/* Condition Card 2 */}
          <div className="group bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="bg-gradient-to-br from-pink-100 to-pink-50 p-4 rounded-xl mb-6 w-fit group-hover:scale-110 transition-transform duration-300">
              <Flower2 className="w-8 h-8 text-pink-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Female Hormone Health
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Thyroid, PCOS, perimenopause, menopause, and insulin resistance
              management
            </p>
          </div>

          {/* Condition Card 3 */}
          <div className="group bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="bg-gradient-to-br from-yellow-100 to-yellow-50 p-4 rounded-xl mb-6 w-fit group-hover:scale-110 transition-transform duration-300">
              <Sparkles className="w-8 h-8 text-yellow-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Health Optimisation
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Optimize your wellness at any life stage and reach your full
              health potential
            </p>
          </div>

          {/* Condition Card 4 */}
          <div className="group bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="bg-gradient-to-br from-blue-100 to-blue-50 p-4 rounded-xl mb-6 w-fit group-hover:scale-110 transition-transform duration-300">
              <Shield className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Help maintain wellness
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Proactive health strategies to improve future health outcomes and
              complications
            </p>
          </div>

          {/* Condition Card 5 */}
          <div className="group bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="bg-gradient-to-br from-green-100 to-green-50 p-4 rounded-xl mb-6 w-fit group-hover:scale-110 transition-transform duration-300">
              <ChefHat className="w-8 h-8 text-green-700" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Meal Planning
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Weekly batch cooking guidance so you can make the right dietary
              choices effortlessly
            </p>
          </div>

          {/* Additional Service Card */}
          <div className="group bg-gradient-to-br from-primary to-green-600 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-primary/20">
            <div className="bg-white/20 p-4 rounded-xl mb-6 w-fit group-hover:scale-110 transition-transform duration-300">
              <Sparkles className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3">
              Personalised Plans
            </h3>
            <p className="text-white/90 leading-relaxed">
              evidence-informed nutritional therapy tailored to your unique
              needs and goals
            </p>
          </div>
        </div>
      </div>

      {/* Why Choose Section */}
      <div className="bg-gradient-to-r from-primary/5 to-green-400/5 py-16 md:py-20">
        <div className="container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Why Choose My Approach
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              A holistic, evidence-informed approach focused on your unique
              circumstances
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-primary to-green-600 text-white font-bold text-xl mb-4">
                ✓
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Evidence-Informed
              </h3>
              <p className="text-gray-600 leading-relaxed">
                All recommendations grounded in scientific research and clinical
                best practices
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-primary to-green-600 text-white font-bold text-xl mb-4">
                ✓
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Personalised
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Tailored specifically to your unique health status, goals, and
                lifestyle
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-primary to-green-600 text-white font-bold text-xl mb-4">
                ✓
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Compassionate
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Understanding, supportive, and focused on sustainable, long-term
                changes
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Reviews Carousel */}
      <div className="container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 p-6 sm:p-8 lg:p-10">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
              Client Reviews
            </h2>
            <p className="text-gray-600">
              Real feedback from women I have supported
            </p>
          </div>

          <div className="relative">
            <div className="absolute -top-3 -left-2 text-primary/20">
              <Quote className="w-10 h-10" />
            </div>

            <div className="bg-gradient-to-r from-primary/5 to-green-400/5 rounded-2xl p-6 sm:p-8 border border-primary/10 min-h-[340px] sm:min-h-[300px] text-left">
              <div className="space-y-3 text-gray-700 leading-relaxed text-sm sm:text-base">
                {selectedReview.review.map((paragraph, index) => (
                  <p key={`${selectedReview.name}-${index}`}>{paragraph}</p>
                ))}
              </div>

              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mt-6">
                — {selectedReview.name}
              </h3>
            </div>

            <div className="mt-6 flex items-center justify-between gap-4">
              <button
                onClick={goToPreviousReview}
                className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-primary/20 text-primary hover:bg-primary hover:text-white transition-all duration-300"
                aria-label="Previous review"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>

              <div className="flex items-center gap-2">
                {reviews.map((review, index) => (
                  <button
                    key={review.name}
                    onClick={() => setActiveReview(index)}
                    className={`h-2.5 rounded-full transition-all duration-300 ${
                      activeReview === index
                        ? "w-8 bg-primary"
                        : "w-2.5 bg-gray-300 hover:bg-primary/50"
                    }`}
                    aria-label={`Show review from ${review.name}`}
                  />
                ))}
              </div>

              <button
                onClick={goToNextReview}
                className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-primary/20 text-primary hover:bg-primary hover:text-white transition-all duration-300"
                aria-label="Next review"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Menopause Breakfast Booklet Section */}
      {/* <div className="bg-gradient-to-r from-pink-50/60 to-green-50/60 py-16 md:py-20">
        <div className="container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
              Free Menopause Breakfast Guide
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              A practical PDF booklet with breakfast ideas to support metabolic
              changes during menopause.
            </p>
          </div>

          <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 p-8 sm:p-10 lg:p-12">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div>
                <div className="inline-flex items-center gap-2 bg-pink-50 text-pink-700 px-4 py-2 rounded-full mb-4 text-sm font-semibold">
                  <BookOpen className="w-4 h-4" />
                  Free PDF Booklet
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                  Breakfast ideas to support metabolic changes during menopause
                </h3>
                <p className="text-gray-600 leading-relaxed max-w-2xl">
                  These breakfasts are designed to support your blood glucose
                  levels, improve satiety and reduce cravings, address hormonal
                  health, and manage brain fog.
                </p>
              </div>

              <a
                href={
                  "/booklets/Breakfast ideas for metabolic health in menopause.pdf"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary to-green-600 hover:from-green-700 hover:to-green-700 text-white font-semibold px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 whitespace-nowrap"
                aria-label="Open menopause breakfast booklet PDF"
              >
                View Booklet
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div> */}
      {/* CTA Section */}
      <div className="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="bg-gradient-to-r from-primary via-green-600 to-primary rounded-3xl shadow-2xl p-8 sm:p-12 lg:p-16 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Start Your Journey?
          </h2>
          <p className="text-lg sm:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Book a complimentary 20-minute discovery call to discuss your health
            goals and how I can help (consultations available in-person or
            online)
          </p>
          <button
            onClick={() =>
              window.open(
                "https://www.bookable.page/aleksandra",
                "_blank",
                "noopener,noreferrer",
              )
            }
            className="bg-white text-primary hover:bg-gray-100 font-bold px-10 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-lg transform hover:scale-105"
          >
            Book Your Free Call Today
          </button>
          <p className="mt-6 text-white/80 text-base">
            No obligation, no pressure — just a friendly conversation about your
            health
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
